export default __webpack_public_path__ + "static/media/ad.b4cda8b3.png";